<template>
  <b-card-header header-tag="header" class="header row" role="tab">
    <h5 :class="['panel-header-title', titleClassName]">{{ title }}</h5>
    <div :class="['d-flex', 'align-items-center', 'justify-content-end', buttonsWrapperClassName]">
      <slot></slot>
      <MaterialIconButton
        :iconName="isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
        :size="27"
        className="toggleButton"
        :onClick="handleToggleButtonClick" />
    </div>
  </b-card-header>
</template>

<script>
import MaterialIconButton from '@components/common/MaterialIconButton.vue'

export default {
  components: {
    MaterialIconButton
  },
  props: {
    title: {
      type: String,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    },
    onToggleButtonClick: {
      type: Function,
      required: true
    },
    titleClassName: String,
    buttonsWrapperClassName: String
  },
  methods: {
    handleToggleButtonClick (event) {
      event.preventDefault()
      this.onToggleButtonClick(event)
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  border: none;
  padding: 24px;
  background-color: transparent;

  .panel-header-title {
    flex: 1 0;
    margin-bottom: 0;
    padding-left: 0;
  }
}

.toggleButton {
  display: block;
  margin: -3px 0;
  cursor: pointer;
}
</style>
